import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { LocaleService } from '@markant-platform/shared/util-locale';
import { take } from 'rxjs';
import { AppConfigService } from '@markant-platform/shared/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UpgradeSuggestedStoragePrefix } from '@markant-platform/cartridge/model';
import { removeStorageKeysStartingWith } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.scss'],
})
export class LogoutPageComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly localeService: LocaleService
  ) {
    this.authService.isAuthenticated$.pipe(take(1), takeUntilDestroyed()).subscribe(isAuthenticated => {
      if (isAuthenticated) {
        this.authService.logout({
          logoutParams: {
            returnTo: AppConfigService.appConfiguration.logoutPageUrl,
          },
        });
        removeStorageKeysStartingWith(UpgradeSuggestedStoragePrefix);
      }
    });
  }

  /**
   * calls login workflow with set language
   */
  login(): void {
    let storedLanguage = localStorage.getItem('language') ?? '';

    if (storedLanguage) {
      storedLanguage = this.localeService.changeLanguageCodeToAdaptAuth0AvailableLanguages(storedLanguage);
    }

    this.authService.loginWithRedirect({
      authorizationParams: {
        ui_locales: storedLanguage,
      },
    });
  }
}
